export const trendSplineConfig = (data) => {
  return {
    chart: {
      type: "spline",
    },
    title: {
      text: "",
      align: "left",
      style: {
        color: "black",
        align: "left",
        textAlign: "left",
      },
    },
    xAxis: {
      labels: {
        groupedOptions: [
          {
            style: {
              color: "black", // set red font for labels in 1st-Level
            },
          },
        ],
      },
      categories: data.catagoriesArr,
      labels: {
        step: 1,
      },
    },

    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false,
        },
      },
      spline: {
        dataLabels: {
          enabled: true,
        },
        enableMouseTracking: true,
        color: "#7030a0",
      },
    },
    series: [{ name: "", data: data.chartValues }],
    exporting: { enabled: false },
  };
};

export const reportBarConfig = (data, numberSelected) => {
  // This destructuring happen to take deep copy of object due to some resone highchart overwriiten array value
  const actualCount = {
    xAxisArray: data.categoryArr,
    chartValues: [...data.chartValues],
    percentageCount: [...data.percentageCount],
  };
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
      align: "left",
    },
    xAxis: {
      categories: actualCount.xAxisArray,
      crosshair: true,
      accessibility: {
        description: "Countries",
      },
      labels: {
        step: 0,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      pointFormat: `<span>{point.y:.f}${
        numberSelected === "num" ? "" : "%"
      }<br> </span>`,
    },
    colors: ["#7030a0"],
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        color: "#7030a0",
        data:
          numberSelected === "num"
            ? actualCount.chartValues
            : actualCount.percentageCount,
        dataLabels: {
          enabled: true,
          color: "#000",
          format: `{point.y:.0f}${numberSelected === "num" ? "" : "%"}`,
          style: {
            fontSize: "10px",
            fontWeight: "bold",
          },
        },
      },
    ],
    exporting: { enabled: false },
  };
};

export const horizontalBarGraph = (data, districtKey) => {
  // This destructuring happen to take deep copy of object due to some resone highchart overwriiten array value

  const actualCount = {
    xAxisArray: data.diagnosedConditionArr,
    chartValues: JSON.parse(JSON.stringify(data.diagnosedConditionValue)),
    percentageCount: JSON.parse(JSON.stringify(data.diagnosedConditionPercent)),
  };

  return {
    chart: {
      type: "bar", // Horizontal bar chart
      marginRight: 40,
      spacing: [10, 40, 20, 10],
    },
    title: {
      text: "",
      align: "center",
    },
    xAxis: {
      categories: actualCount.xAxisArray,
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      pointFormat: `<span>{point.y:0f}${
        districtKey === "num" ? "" : "%"
      }<br> </span>`,
    },

    plotOptions: {
      bar: {
        bandWidth: 0,
        dataLabels: {
          enabled: true,
          format: `{point.y:.0f}${districtKey === "num" ? "" : "%"}`,
        },
      },
    },
    legend: {
      enabled: false, // No need for a legend if there’s only one series
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    series:
      districtKey === "num"
        ? actualCount.chartValues
        : actualCount.percentageCount,
  };
};

export const pieChartConfig = (data) => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: null,
    },
    tooltip: {
      valueSuffix: "",
    },
    subtitle: {
      text: null,
    },
    plotOptions: {
      pie: {
        showInLegend: true,
      },
      series: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: [
          {
            enabled: false,
            distance: 20,
          },
          {
            enabled: true,
            distance: -40,
            format: "{point.percentage:.0f}%",
            style: {
              fontSize: "1.2em",
              textOutline: "none",
              opacity: 0.7,
            },
            filter: {
              operator: ">",
              property: "percentage",
              value: 10,
            },
          },
        ],
      },
    },
    series: [
      {
        colorByPoint: true,
        data,
      },
    ],
  };
};
